<template>
  <CustomUpdateDialog
    dialogTitle="تغییر وضعیت کلاس ترمیک به در اتمام یافته"
    dialogId="finish-termic-courses-status-dialog"
    okTitle="بله"
    cancelTitle="خیر"
    :isOkDisabled="isLoading"
    @ok="sendFinishTermicCourseRequestByAdmin"
  >
    <BCol cols="12">
      <p>
        آیا از تغییر وضعیت کلاس ترمیک
        <span style="font-weight: bold">{{
          termicCourseDetails && termicCourseDetails.termicCourseName
            ? termicCourseDetails.termicCourseName
            : ""
        }}</span>
        به در اتمام یافته اطمینان دارید؟
      </p>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    termicCourseDetails: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async sendFinishTermicCourseRequestByAdmin() {
      try {
        this.isLoading = true;
        const _this = this;
        const finishTermicCourse = new FinishTermicCourse(_this);
        finishTermicCourse.setRequestParam({
          termicCourseId: this.termicCourseDetails.id,
        });
        await finishTermicCourse.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت کلاس ترمیک به اتمام یافته تغییر کرد.",
              },
            });
            this.$bvModal.hide("finish-termic-courses-status-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { FinishTermicCourse } from "@/libs/Api/TermicCourses";
</script>
